import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Axios Request
import { fetchSinglePost } from '../requests/singlepost_request';

import Header from '../components/Header';
import PeopleList from '../components/Pages/People/PeopleList';
import Modal from '../components/Pages/People/Modal';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import ReadMore from '../components/Pages/ReadMore';

import RenderSingle from '../components/Pages/RenderSingle';

class SinglePageTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalActive: false,
            selectEmployee: '',
            hideOverflow: false,
        };

        // bind functions
        this.handleClick = this.handleClick.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    componentDidMount() {
        document.title = `People - Friends for Brands`;
        window.scrollTo(0, 0);
        window.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    }
    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        let slug = this.props.match.path;
        slug = slug.substring(1);
        if (willMount) {
            this.props.fetchSinglePost('pages', slug);
        }
    }

    hideModal() {
        document.body.removeAttribute('class');
        return this.setState({
            modalActive: false,
        });
    }

    handlePress(e) {
        if (e.keyCode === 27) {
            return this.setState({
                modalActive: false,
            });
        }
    }

    handleClick(e) {
        document.body.classList.add('overflow-hidden');
        return this.setState({
            modalActive: !this.state.modalActive,
            selectEmployee: e.currentTarget.getAttribute('data-user-id'),
        });
    }

    handleKeyPress(e) {
        document.body.removeAttribute('class');
        if (e.keyCode === 27) {
            return this.setState({
                modalActive: false,
            });
        }
    }

    render() {
        const GET_THE_POSTS = this.props.posts;
        const DID_FETCH = GET_THE_POSTS.fetched;
        const ACF_FIELD = DID_FETCH && GET_THE_POSTS.posts[0].acf;

        return (
            <div className="single page people">
                <Header />
                <Modal
                    modalActive={this.state.modalActive}
                    hideModal={this.hideModal}
                    handlePress={this.handlePress}
                    employeeData={
                        this.props.posts.fetched &&
                        this.props.posts.posts[0].acf.employee_repeater
                    }
                    selectEmployee={this.state.selectEmployee}
                />
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <Loader loaded={this.props.posts.fetched} />
                            <div className="fadeIn">
                                <RenderSingle posts={this.props.posts} />
                                <PeopleList
                                    handleClick={this.handleClick}
                                    employeeData={
                                        this.props.posts.fetched &&
                                        this.props.posts.posts[0].acf
                                            .employee_repeater
                                    }
                                />
                            </div>
                            <ReadMore
                                moreLeft={ACF_FIELD.readmore_left}
                                moreRight={ACF_FIELD.readmore_right}
                                router={this.props.location.pathname}
                            />
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(SinglePageTeam)
);



// WEBPACK FOOTER //
// ./src/containers/SinglePageTeam.jsx